export const FETCH_ROLE_SUCCESS = "FETCH_ROLE_SUCCESS";
